import React from "react";
import { Box, Tooltip } from "@mui/joy";
import CommonModal from "../../common/CommonModal";
import DarkTypography from "../../common/DarkTypography";
import { colorTokens, withAlpha } from "../../../styles/globalStyles";

interface QRCodeRegenerateModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (color: string) => void;
}

const PASTEL_COLORS: { hex: string; name: string }[] = [
  { hex: "#B39DDB", name: "Violet clair" }, // Purple 300
  { hex: "#64B5F6", name: "Bleu clair" }, // Blue 300
  { hex: "#FFFFFF", name: "Blanc" }, // White
  { hex: "#81C784", name: "Vert clair" }, // Green 300
  { hex: "#FFF176", name: "Jaune" }, // Yellow 300
  { hex: "#E57373", name: "Rouge clair" }, // Red 300
  { hex: "#F06292", name: "Rose" }, // Pink 300
  { hex: "#FFB74D", name: "Orange clair" }, // Orange 300 (8ème)
];

export default function QRCodeRegenerateModal({
  open,
  onClose,
  onConfirm,
}: QRCodeRegenerateModalProps) {
  const [selected, setSelected] = React.useState<string>(PASTEL_COLORS[0].hex);

  React.useEffect(() => {
    if (open) setSelected(PASTEL_COLORS[0].hex);
  }, [open]);

  if (!open) return null;

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title="Couleur QR"
      size="sm"
      onConfirm={() => onConfirm(selected)}
      confirmLabel="Régénérer"
    >
      <DarkTypography level="h4" sx={{ mb: 1 }}>
        Couleur de fond
      </DarkTypography>

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1.5, mt: 1 }}>
        {PASTEL_COLORS.map(({ hex, name }) => (
          <Tooltip key={hex} title={`${name}`} variant="soft" placement="top">
            <Box
              onClick={() => setSelected(hex)}
              sx={{
                height: 44,
                borderRadius: 1.5,
                cursor: "pointer",
                border:
                  selected === hex
                    ? `2px solid ${colorTokens.accent.primary}`
                    : "2px solid transparent",
                boxShadow:
                  selected === hex
                    ? `0 0 0 2px ${withAlpha(colorTokens.accent.primary, 0.25)}`
                    : "none",
                backgroundColor: hex,
              }}
            />
          </Tooltip>
        ))}
      </Box>
    </CommonModal>
  );
}
